module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAcCAYAAACptnW2AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAK8AAACvABQqw0mAAAABZ0RVh0Q3JlYXRpb24gVGltZQAwOC8xMi8xMKNAeX0AAAAYdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3Jrc0+zH04AAAD6SURBVCiRfZA9TgMxFIS/9TqsACVahMSfKKCgz0kQl+Ac5CwcgQvQ0HMImhQgSEgUAfYbCptdr0AUU7zxvDfjqY6uHwDOgRlwCbQemAL3492mPTnYYzLewQM37WS7vTg7BoEMPHB1eriPBNFEjMIDNM2IaMZXENEyiYRMWBRmwgGYfiBMmQQh9UhKS4OpWC9VnVLJq1Mn0jRAVgpDnbvvb1rGwKjPmsn8MLipIqf+z6nff5cV6q6lopC+pb9uWl43K1pKlYCr0uQBQog45xh5hwQOuFusNgDUtaPZqnHA7H39sXx5WxFCpHYVDngEpuvN5+38ebl4mr/yDZaP/G9E/Ge1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client/l_left.png
// module id = 786
// module chunks = 110